import { render, staticRenderFns } from "./taskListDialog.vue?vue&type=template&id=0457575e&scoped=true"
import script from "./taskListDialog.vue?vue&type=script&lang=js"
export * from "./taskListDialog.vue?vue&type=script&lang=js"
import style0 from "./taskListDialog.vue?vue&type=style&index=0&id=0457575e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457575e",
  null
  
)

export default component.exports